var exports = {
  "M": "topicLabel__WcsFw6",
};

module.exports = exports;
